module.exports = __webpack_public_path__ + "static/media/blast-wide.c30ed63d.png";